module.exports = __webpack_public_path__ + "img/ability-lab.95d7ef05.svg";